import React, { useState, useEffect } from "react";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
import { Building2, ChevronDown, Plus } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "./ui/dropdown-menu";

export default function CompanySwitcher() {
  const { user, activeCompany, switchCompany } = useAuth();
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    if (user) {
      api.get("/companies").then((r) => setCompanies(r.data));
    }
  }, [user]);

  if (!activeCompany) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="company-switcher"
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-white/10 bg-white/5 hover:bg-white/10 transition-all"
        >
          <Building2 size={14} className="text-blue-400" />
          <span className="text-sm font-medium max-w-[160px] truncate">
            {activeCompany.name}
          </span>
          <ChevronDown size={14} className="text-slate-400" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="glass border-white/10 min-w-[240px]"
      >
        {companies.map((c) => (
          <DropdownMenuItem
            key={c.id}
            data-testid={`company-option-${c.id}`}
            onClick={() => switchCompany(c.id)}
            className={`cursor-pointer ${c.id === activeCompany.id ? "text-blue-300" : ""}`}
          >
            <Building2 size={14} className="mr-2" />
            <span className="truncate">{c.name}</span>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <a href="/app/settings" className="cursor-pointer">
            <Plus size={14} className="mr-2" /> Gestionar empreses
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
